export default {
    common: {
        price: "Price",
        from: "From",
        buy: "Buy",
        balance: "Balance",
        selected: "selected",
        search: "Search",
        cancel: "Cancel",
        sell: "Sell",
        storage: "Storage",
        use: "Use",
        ok: "OK",
        murkup: "Murkup",
        options: "Options",
        next: "Next",
        start: "Start"
    },

    property: {
        souvenir: "Souvenir",
        rarity: "Rarity",
        quality: "Quality",
        origin: "Origin",
        collection: "Collection",
        exclusive: "Exclusive",
        percentOfInventory: "{d} of your inventory price",
        couldContain: "Your inventory could contain {d} of these",

        TypeMachineguns: "Machineguns",
        TypeShotguns: "Shotguns",
        TypeSniperRifles: "Sniper Rifles",
        TypeRifles: "Rifles",
        TypeSMGs: "SMGs",
        TypePistols: "Pistols",
        TypeGloves: "Gloves",
        TypeKnifes: "Knifes",

        RarityGold: "Extraordinary",
        RarityCovert: "Covert",
        RarityClassified: "Classified",
        RarityRestricted: "Restricted",
        RarityMilspec: "Mil-spec",
        RarityIndustrial: "Industrial",
        RarityBase: "Consumer",

        QualityFN: "Factory New",
        QualityMW: "Minimal Wear",
        QualityFT: "Field-Tested",
        QualityWW: "Well-Worn",
        QualityBS: "Battle-Scarred",

        OriginFoundinCrate: "Found in Crate",
        OriginCrafted: "Crafted",
        OriginPurchased: "Purchased",
        OriginUpgraded: "Upgraded",
        OriginTradedUp: "Traded Up",
        OriginUnknown: "Unknown"
    },

    filters: {
        allTypes: "All Types",
        allQualities: "All Qualities",
        allRarities: "All Rarities"
    },

    tabs: {
        menu: "Menu",
        cases: "Cases",
        profile: "Profile",
        casino: "Casino",
        statistics: "Statistics",
        settings: "Settings",
    },

    cases: {
        bestDrop: "Your Best Drop",
        cases: "Cases",
        special: "Special",
        openCase: "Open Case",
        openCollection: "Open Collection"
    },

    profile: {
        showcase: "Showcase",
        inventory: "Inventory",
        special: "Special",
        rifles: "Rifles",
        pistols: "Pistols",
        totalItems: "Total Items",
        totalStorages: "Total Storages",
        selectForShowcase: "Select for Showcase",
        findInShop: "Find in Shop",
        removeFromShowcase: "Remove From Showcase",
        available: "Available",
        selectAll: "Select All",
        selectAllHint: "Select all {s} ({d})"
    },

    casino: {
        roulette: "Luck Roulette",
        craft: "Craft",
        contract: "Contract",
        upgrader: "Upgrader",
        shop: "Shop",
        crash: "Crash"
    },

    contract: {
        hint: "choose from 3 to 5 items",
        totalPrice: "Contract Price",
        possibleRange: "Possible Win Range",
        sign: "Sign Contract",
        new: "New Contract"
    },
    
    craft: {
        rarity: "Rarity",
        extra: "Extra",
        defaultSubtitle: "Standard Items",
        stattrackSubtitle: "Items with StatTrak™ Technology",

        craftPrice: "Craft Price",
        craftRange: "Outcome Range",
        signCraft: "Sign Craft",
        newCraft: "New Craft"
    },

    upgrader: {
        hint: "select an item",
        multiplier: "Multiplier",
        priority: "Type Priority",
        upgrade: "Upgrade",
        error: "There are no items available. Choose a different item or multiplier!"
    },

    shop: {
        hint: "Select Collection",
        hint2: "Select the item you want to buy"
    },

    crash: {
        bet: "Bet",
        totalAmount: "Total Amount",
        autoStopAt: "Auto Stop At",
        cashOut: "Cash Out",
        multiplier: "Multiplier",
        timePassed: "Time Passed",
        profit: "Profit",
        autoStop: "Auto Stop",
        latest: "Latest",

        betError: "Minimal Bet is {d}$",
        autoStopError: "Minimal Auto Stop is x{d}"
    },

    roulette: {
        bet: "Bet",
        roll: "Roll!",
        error: "Minimal bet: {d}!"
    },

    ItemPage: {
        previousPage: "Previous Page",
        nextPage: "Next Page",
        openFilters: "Open Filters",
        nothingFound: "There is nothing here yet!",
        resetFilters: "Reset filters"
    },

    modals: {
        sellItems: {
            title: "Sell {d} {s}",
            line1: "Are You sure you want to sell {d} items?",
            line2: "After the sale You will receive {d}"
        },

        storageBuy: {
            title: "Buy Storage",
            line1: "Buy Storage for {d}?",
            line2: "Enter Storage Name",
            line3: "Warning: Name can't be changed in the future",
            placeholder: "Storage Name",
            action: "Buy for {d}",
            invalidName: "Invalid storage name!",
            nameTaken: "This name is already taken!",
            validName: "This name can be used"
        },

        settings: {
            language: "Language",
            currency: "Currency",
            volume: "Master Volume"
        },

        profilePicture: {
            title: "Profile Picture",
            upload: "Upload New",
            delete: "Delete Picture"
        }
    },

    Plural: {
        items: [ "item", "items" ]
    }
}